const PlusIcon = (props) => {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9 24H8.1C4.8 24 3.3 23.2 2.05 22C0.8 20.7 0 19.2 0 15.9V8.1C0 4.8 0.8 3.3 2 2.05C3.3 0.8 4.8 0 8.1 0H15.9C19.2 0 20.7 0.8 21.95 2C23.2 3.3 24 4.8 24 8.1V15.9C24 19.2 23.2 20.7 22 21.95C20.7 23.2 19.2 24 15.9 24ZM8.1 1.5C5 1.5 3.9 2.3 3.05 3.1C2.3 3.9 1.5 5 1.5 8.1V15.9C1.5 19 2.3 20.1 3.1 20.95C3.9 21.75 5 22.5 8.1 22.5H15.9C19 22.5 20.1 21.7 20.95 20.9C21.75 20.1 22.5 19 22.5 15.9V8.1C22.5 5 21.7 3.9 20.9 3.05C20.1 2.3 19 1.5 15.9 1.5H8.1Z"
        fill="#262626"
      />
      <path
        d="M18.15 12.75H5.85001C5.45001 12.75 5.10001 12.4 5.10001 12C5.10001 11.6 5.45001 11.25 5.85001 11.25H18.15C18.55 11.25 18.9 11.6 18.9 12C18.9 12.4 18.55 12.75 18.15 12.75Z"
        fill="#262626"
      />
      <path
        d="M12 18.9C11.6 18.9 11.25 18.55 11.25 18.15V5.84998C11.25 5.44998 11.6 5.09998 12 5.09998C12.4 5.09998 12.75 5.44998 12.75 5.84998V18.15C12.75 18.55 12.4 18.9 12 18.9Z"
        fill="#262626"
      />
    </svg>
  );
};

export default PlusIcon;
